module.exports = __webpack_public_path__ + "img/职业健康安全管理体系认证证书.26994180.png";